export default __webpack_public_path__ + "static/media/WomenCare.86783558.webp";